import { TemplateType } from 'hooks/usePaginatedTemplatesSearch/usePaginatedTemplatesSearch.types';

import { UserType, UserTypes } from './user.types';

/**
 * Check if a user has the permission to access a resources with permission 'permissionCheck'
 *
 * @param userType the user's privilege
 * @param permissionCheck the permission of the resource
 * @returns boolean indicating if a user has the permission
 */
export const hasResourcePermission = (userType: UserType, permissionCheck: UserType) => {
  // free permission means all users have the permisison
  if (permissionCheck === UserTypes.Free) return true;

  // Enterprise users can access all resources
  if (userType === UserTypes.Enterprise) return true;

  // Business users can access all resources
  if (userType === UserTypes.Business) return true;

  // The user can access the resource which has the same permission as the user,
  if (userType === permissionCheck) return true;

  // Education users can access premium resources
  if (userType === UserTypes.Education && permissionCheck === UserTypes.Premium) return true;

  // Admin users can access all resources
  if (userType === UserTypes.Admin) return true;

  return false;
};

/**
 * Check if a user has permission for a specific template
 *
 * @param userType
 * @param templatePermission
 * @returns
 */
export const hasTemplatePermission = (userType: UserType, templatePermission: TemplateType) => {
  const allowedTemplateTypes = [TemplateType.Free];
  switch (userType) {
    case 'education':
    case 'premium':
      allowedTemplateTypes.push(TemplateType.Premium);
      break;
    case 'enterprise':
    case 'business':
      allowedTemplateTypes.push(TemplateType.Premium, TemplateType.Business);
      break;
    default:
      break;
  }

  return allowedTemplateTypes.includes(templatePermission);
};
